const map = {
  search: {
    title: 'Address...' // TODO: translate
  },
};

export default map;
